import React, {useEffect, useState} from 'react';
import { Modal, Button, Select, Radio, Input, Typography, Space } from 'antd';
import {internalApi} from "../../../common/axios";
import toast from "react-hot-toast";

const { Option } = Select;
const { TextArea } = Input;

const EmailSendModal = ({emailModalOpen, setEmailModalOpen, emailList, csnList}) => {
    const [currentTemplate, setCurrentTemplate] = useState({});
    const [emailTitle, setEmailTitle] = useState('');
    const [emailContent, setEmailContent] = useState('');
    const [template, setTemplate] = useState([]);
    const [isSending, setIsSending] = useState(false);

    const fetchMacro = async () => {
        const result = await internalApi.get('/css/macro');
        setTemplate(result.data.rows);
    }

    useEffect(() => {
        fetchMacro();
    }, []);

    const handleSetCurrentTemplate = (value) => {
        setCurrentTemplate(value);
        setEmailTitle('');
        setEmailContent('')
    }

    const handleSetTemplateContent = (value) => {
        const template = JSON.parse(value);
        setEmailTitle(template.title);
        setEmailContent(template.content);
    }

    const handleSendEmail = async () => {
        setIsSending(true);
        const result = await internalApi.post('/css/sendEmail2', {
            emailList,
            title: emailTitle,
            content: emailContent,
            csnList,
        });

        toast.success(result.data.message);
        if (result.status === 200) {
            setEmailModalOpen(false);
            setEmailTitle('');
            setEmailContent('');
        }
        setIsSending(false);
    }

    return (
        <Modal
            open={emailModalOpen}
            onCancel={() => setEmailModalOpen(false)}
            footer={null}
            width={700}
            title={<Typography.Title level={4} style={{margin: 0}}>이메일 보내기</Typography.Title>}
        >
            <Space direction="vertical" style={{width: '100%'}} size="middle">
                <Select
                    placeholder="[템플릿]라벨 선택"
                    style={{width: '60%'}}
                    onChange={value => handleSetCurrentTemplate(template.find(t => t.value === value))}
                    value={currentTemplate.value}
                    allowClear
                >
                    {template.map((option) => (
                        <Option key={option.value} value={option.value}>
                            {option.label}
                        </Option>
                    ))}
                </Select>
                {Object.keys(currentTemplate).length > 0 && (
                    <Radio.Group
                        onChange={e => handleSetTemplateContent(e.target.value)}
                        style={{marginBottom: 8}}
                    >
                        {Object.keys(currentTemplate).map((key) => (
                            <Radio key={key} value={JSON.stringify(currentTemplate[key])}>{key}</Radio>
                        ))}
                    </Radio.Group>
                )}
                <Typography.Text>받는 사람: {emailList.join(', ')}</Typography.Text>
                <Input
                    placeholder="Title"
                    value={emailTitle}
                    onChange={e => setEmailTitle(e.target.value)}
                />
                <TextArea
                    placeholder="Content"
                    value={emailContent}
                    onChange={e => setEmailContent(e.target.value)}
                    autoSize={{ minRows: 10, maxRows: 25 }}
                />
                <Space style={{justifyContent: 'flex-end', width: '100%'}}>
                    <Button onClick={() => setEmailModalOpen(false)} disabled={isSending}>취소</Button>
                    <Button type="primary" onClick={handleSendEmail} loading={isSending}>보내기</Button>
                </Space>
            </Space>
        </Modal>
    );
}

export default EmailSendModal;